import { Layout, ButtonContainer, Button, Fieldset } from '@vwfs-bronson/bronson-react';
import { t } from 'i18next';
import React from 'react';
import { FormHelpers } from '../../screens/utils';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  isSummaryMode?: boolean;
  formHelpers?: FormHelpers;
};

export const FormSectionSubmitButton: React.FC<Props> = ({ onClick, formHelpers }) => {
  const { summaryMode, isEditing, isDisabledFormSummary } = formHelpers ?? {};
  const showSubmitButton = !summaryMode || isEditing;

  if (!showSubmitButton) return null;

  return (
    <Fieldset.Row>
      <Layout right>
        <Layout.Item default="1/6">
          <ButtonContainer right>
            <Button disabled={isDisabledFormSummary} onClick={onClick}>
              {summaryMode ? t('customerDataPage:summaryNextFormButton') : t('customerDataPage:nextFormButton')}
            </Button>
          </ButtonContainer>
        </Layout.Item>
      </Layout>
    </Fieldset.Row>
  );
};
